import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'th_TH',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '37ecc23f-b57d-47ba-95f1-706b9fef5dc1',
  ''
);
